<div class="row pt-1">
  <div class="col-7">
    {{ 'CART_ARTICLE_SKU_TOTAL' | translate: { article: cartTotalRows, sku: cartTotalItems } }}
  </div>
  <div class="col-5 mb-5">
    <div class="font-weight-bold item-info text-right price-total">
      <span class="text-primary"><span translate>CART_SUBTOTAL</span>: </span>
      <lib-price [price]="cartTotalValue" [currency]="cartCurrency"></lib-price>
    </div>
    @if (isDisabledByAvailability) {
      <span class="warning-availability" translate>
        AVAILABILITY_EXCEEDED
      </span>
    }
  </div>
</div>

<div class="row align-items-end">
  <div class="col-6 col-lg-8">
    <button
      *ngIf="!isFirstStep"
      type="button"
      class="btn btn-outline-primary btn-sm checkout-btn-previous checkout-btn"
      (click)="prevClicked.emit()"
      translate
    >
      {{ prevBtnText }}
    </button>
  </div>

  <div class="col-6 col-lg-4">
    <div class="row align-items-end">
      <div class="col-12 col-md-6">
        <button
          type="button"
          class="btn btn-outline-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn"
          (click)="createQuotation()"
          *ngIf="isLastStep"
        >
          {{ 'SEND_QUOTE' | translate }}
        </button>
      </div>
      <div class="col-12 col-md-6" *ngIf="!isDisabled">
        <button
          class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next checkout-btn"
          type="button"
          (click)="nextClicked.emit()"
          [disabled]="isDisabledByAvailability"
        >
          <span translate>{{ nextBtnText }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
